import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/newhome';
import Whitepaper from './pages/whitepaper';
const w = window.innerWidth;
const Main = () => {
  // const lang = (window.location.pathname.toString().split("/")[window.location.pathname.toString().split("/").length - 1]).toUpperCase()
  const anotherLang = {
    'pt-br': {
      item1: "Quem somos",
      item2: "Planejamento"
    },
    'en-us': {
      item1: "About us",
      item2: "Road map"
    },
  }
  useEffect(() => {
    //getQuery('lang') == null ? 'BSC' : getQuery('chain')
    if (getQuery('lang') == null) {
      window.location.href = "?lang=pt-br"
    }
  }, []);

  function getlang() {
    return getQuery('lang') == null ? "pt-br" : getQuery('lang')
  }
  function getdata() {
    return anotherLang[getlang()]
  }
  function getQuery(query) {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const foo = params.get(query);
    return foo
  }
  return (
    <>
      <div style={{ height: "100px", width: "100%", maxWidth: "1280px", margin: "auto", display: "grid" }}>
        {w < 720 ?
          <>
            <div style={{ height: "50px", width: "100%", display: "grid", gridTemplateColumns: "100px auto 100px", margin: "auto", gap: "10px", color: "#fff", padding: " 0px 5px" }}>
              <p style={{ textAlign: "center", margin: "auto", fontSize: "30px" }}>ZAZUCOIN</p>
              <div></div>

            </div>
            <div style={{ height: "50px", display: "grid", gridTemplateColumns: " auto auto auto auto auto", margin: "auto", gap: "5px", color: "#fff" }}>

              <p onClick={() => { window.location.href = "/whitepaper" }} style={{
                height: "min-content",
                width: "100%",
                margin: "auto",
                textAlign: "center",
                fontSize: "12px",
                cursor: "pointer"
              }}>WhitePaper</p>
              <p onClick={() => { window.location.href = "#QuemSomos" }} style={{
                height: "min-content",
                width: "100%",
                margin: "auto",
                textAlign: "center",
                fontSize: "12px",
                cursor: "pointer"
              }}>{getdata().item1}</p>

              <p onClick={() => { window.location.href = "#Planejamento" }} style={{
                height: "min-content",
                width: "100%",
                margin: "auto",
                textAlign: "center",
                fontSize: "12px",
                cursor: "pointer"
              }}>{getdata().item2}</p>
              <p onClick={() => { window.location.href = "#Tokenomics" }} style={{
                height: "min-content",
                width: "100%",
                margin: "auto",
                textAlign: "center",
                fontSize: "12px",
                cursor: "pointer"
              }}>Tokenomics</p>
              <div style={{
                height: "35px",
                width: "75px",
                display: "grid",
                margin: "auto",
                gap: "2px",
                borderRadius: "10px",
                border: "2px solid #ffffff80",
                gridTemplateColumns: "auto 1px auto",
              }}>
                <p onClick={() => { window.location.href = "?lang=pt-br" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "12px",
                  cursor: "pointer"
                }}>pt</p>
                <p style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "10px",
                  cursor: "pointer"
                }}>|</p>
                <p onClick={() => { window.location.href = "?lang=en-us" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "12px",
                  cursor: "pointer"
                }}>en</p>
              </div>
            </div>
          </>


          :
          <>
            <div style={{ height: "100px", width: "100%", display: "grid", gridTemplateColumns: "50px 100px auto auto", margin: "auto", gap: "10px", color: "#fff" }}>
              <div onClick={() => { }} style={{
                cursor: "pointer",
                height: "50px",
                width: "50px",
                color: "#fff",
                margin: "auto",
                background: "url('/zazu.png')",
                backgroundSize: "50px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "grid",
                borderRadius: "10px",
              }}>
                <p style={{ color: "#444" }}></p>
              </div>
              <p style={{ textAlign: "center", margin: "auto", fontSize: "30px" }}>ZAZUCOIN</p>
              <div></div>
              <div style={{ height: "50px", display: "grid", gridTemplateColumns: " auto auto auto auto auto", margin: "auto", marginRight: "0px", gap: "10px", color: "#fff" }}>
                <p onClick={() => { window.location.href = "/whitepaper" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>WhitePaper</p>
                <p onClick={() => { window.location.href = "#QuemSomos" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>{getdata().item1}</p>

                <p onClick={() => { window.location.href = "#Planejamento" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>{getdata().item2}</p>
                <p onClick={() => { window.location.href = "#Tokenomics" }} style={{
                  height: "min-content",
                  width: "100%",
                  margin: "auto",
                  textAlign: "center",
                  fontSize: "14px",
                  cursor: "pointer"
                }}>Tokenomics</p>
                <div style={{
                  height: "35px",
                  width: "75px",
                  display: "grid",
                  margin: "auto",
                  gap: "2px",
                  borderRadius: "10px",
                  border: "2px solid #ffffff80",
                  gridTemplateColumns: "auto 1px auto",
                }}>
                  <p onClick={() => { window.location.href = "?lang=pt-br" }} style={{
                    height: "min-content",
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "14px",
                    cursor: "pointer"
                  }}>pt</p>
                  <p style={{
                    height: "min-content",
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "10px",
                    cursor: "pointer"
                  }}>|</p>
                  <p onClick={() => { window.location.href = "?lang=en-us" }} style={{
                    height: "min-content",
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    fontSize: "14px",
                    cursor: "pointer"
                  }}>en</p>
                </div>
              </div>

            </div>
          </>
        }
      </div>

      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/whitepaper' element={<Whitepaper />}></Route>
      </Routes>
    </>

  );
}

export default Main;